import Input from './Input';
import MaskedNumericInput from './MaskedNumericInput/MaskedNumericInput';
import proxyRefToInnerRef, { InputWrapper } from './proxyRefToInnerRef';

export default Input;
export { MaskedNumericInput, proxyRefToInnerRef, InputWrapper };
